/**
 * PendingShowFields — campi per lo stage `pending_show` (motivi + settimane).
 * ★ Fase 59.P2 — estratto da StageTransitionModal.jsx. Comportamento invariato.
 */
import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import i18n from '../../i18n';

// ★ 2026-07-29: Pending Show — 4 checkbox + settimane compilabili
const PENDING_SHOW_OPTIONS_FE = [
  { key: 'rivedersi_x_settimane', needsWeeks: true, get label() { return i18n.t('stageTransition.ps.reviewWeeks', 'Vogliono rivedersi tra X settimane'); } },
  { key: 'confronto_socio_familiare', needsWeeks: false, get label() { return i18n.t('stageTransition.ps.partnerCheck', 'Devono confrontarsi con socio/familiare'); } },
  { key: 'attendono_liquidita', needsWeeks: false, get label() { return i18n.t('stageTransition.ps.awaitLiquidity', 'Attendono liquidità'); } },
  { key: 'valutando_opportunita', needsWeeks: false, get label() { return i18n.t('stageTransition.ps.evaluating', "Stanno valutando l'opportunità"); } },
];

export function PendingShowFields({ form, set }) {
  const toggleReason = (key) => {
    const arr = form.pending_show_reasons || [];
    const has = arr.includes(key);
    set('pending_show_reasons', has ? arr.filter((k) => k !== key) : [...arr, key]);
  };
  return (
    <div className="space-y-3">
      <div className="rounded-md bg-amber-50 border border-amber-200 p-3 text-xs text-amber-900">
        {i18n.t('stageTransition.pendingIntro', 'Il cliente si è presentato ma la decisione è in sospeso. Registra i motivi qui sotto.')}
      </div>
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.reasonsMin', 'Motivi (almeno uno)')} *</Label>
        {PENDING_SHOW_OPTIONS_FE.map((opt) => (
          <div key={opt.key} className="border rounded-md p-2 bg-slate-50/50">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={(form.pending_show_reasons || []).includes(opt.key)}
                onChange={() => toggleReason(opt.key)}
                className="rounded"
                data-testid={`pending-show-${opt.key}`}
              />
              <span className="text-sm">{opt.label}</span>
            </label>
            {opt.needsWeeks && (form.pending_show_reasons || []).includes(opt.key) && (
              <div className="ml-6 mt-2">
                <Label className="text-xs">{i18n.t('stageTransition.weeksNum', 'Numero settimane')}</Label>
                <Input
                  type="number"
                  min="1"
                  max="52"
                  value={form.pending_show_weeks}
                  onChange={(e) => set('pending_show_weeks', e.target.value)}
                  placeholder="Es. 2"
                  className="w-24 mt-1"
                  data-testid="pending-show-weeks-input"
                />
                <p className="text-[10px] text-muted-foreground mt-1">
                  {i18n.t('stageTransition.weeksReminder', 'Al termine, il CRM crea automaticamente un promemoria per l\'agente.')}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.extraNotes', 'Note aggiuntive')}</Label>
        <Textarea
          rows={2}
          value={form.pending_show_notes}
          onChange={(e) => set('pending_show_notes', e.target.value)}
          placeholder={i18n.t('stageTransition.pendingNotesPh', 'Dettagli sulla conversazione, obiezioni emerse, ecc.')}
          className="mt-1"
          data-testid="pending-show-notes"
        />
      </div>
    </div>
  );
}
